var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.228516,
    width: 72,
    height: 72,
    rx: 16,
    fill: "#EBF4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.1639 46.8749L57.1732 46.8698H57.1551L46.5288 41.1119L35.8849 35.3438L25.2405 41.1119L14.6143 46.8698H14.5962L14.6054 46.8749L14.5962 46.88H14.6143L25.2405 52.638L35.8849 58.4061L46.5288 52.638L57.1551 46.88H57.1732L57.1639 46.8749Z",
    fill: "#A0CBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1639 24.7597L57.1732 24.755H57.1551L46.5288 18.9966L35.8849 13.2285L25.2405 18.9966L14.6143 24.755H14.5962L14.6054 24.7597L14.5962 24.7647H14.6143L25.2405 30.5231L35.8849 36.2912L46.5288 30.5231L57.1551 24.7647H57.1732L57.1639 24.7597Z",
    fill: "#0C66E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6143 24.291V47.3436L35.8849 35.8175L14.6143 24.291Z",
    fill: "#BDDBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.155 24.291V47.3436L35.8848 35.8175L57.155 24.291Z",
    fill: "#BDDBFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.b4df1fbbd9e04621154d627de4749d86.svg";
export { ForwardRef as ReactComponent };